import tldList from '@/core/utils/tlds.json';

export const VALID_TLDS = new Set(
    tldList.map((tld) => tld.replace(/^\./, '').toLowerCase()),
);

export const EMAIL_PILL_DOMAINS = [
    'gmail.com',
    'yahoo.com',
    'outlook.com',
    'hotmail.com',
    'icloud.com',
];

export function isValidTld(email: string): boolean {
    const atIndex = email.lastIndexOf('@');
    if (atIndex === -1) return true;
    const domain = email.slice(atIndex + 1);
    if (!domain || !domain.includes('.')) return true;
    const parts = domain.split('.');
    const lastPart = parts[parts.length - 1].toLowerCase();
    return VALID_TLDS.has(lastPart);
}

export function shouldShowEmailPills(email: string): boolean {
    if (!email) return false;
    if (email.includes('@') && email.split('@')[1]?.includes('.')) return false;
    return true;
}

export function applyEmailDomain(email: string, domain: string): string {
    const localPart = email.includes('@')
        ? email.slice(0, email.indexOf('@'))
        : email;
    return `${localPart}@${domain}`;
}
